import { render, staticRenderFns } from "./addUsuario.vue?vue&type=template&id=58a7cf76&scoped=true"
import script from "./addUsuario.vue?vue&type=script&lang=js"
export * from "./addUsuario.vue?vue&type=script&lang=js"
import style0 from "./addUsuario.vue?vue&type=style&index=0&id=58a7cf76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7cf76",
  null
  
)

export default component.exports